<div class="splide" #splideElement>
  <div class="splide__track">
    <ul class="splide__list">
      @for (slide of activeSlides(); track slide.imagePath) {
      <li class="splide__slide">
        <img
          [src]="CDN + '/marketing/' + slide.imagePath"
          [alt]="slide.title"
          (click)="slide.link && openLink(slide.link)"
          [class.cursor-pointer]="slide.link"
        />
      </li>
      }
    </ul>
  </div>
</div>
